import isProductInFav from "./isProductInFav";
import getFavItems from "./getFavItems";
import putFavItems from "./putFavItems";
import dispatch from "../../../components/dispatch";
import {ON_FAVOURITE_REMOVED} from "../../globals";

export default async (product) => {

    if (await isProductInFav(product)) {
        await getFavItems().then((feed) => {
            const index = feed.indexOf(product);
            feed.splice(index, 1);
            putFavItems(feed);
            dispatch(ON_FAVOURITE_REMOVED)
        })
    }

}
